import i18next from 'i18next';

// Override the type for the 't' function
export type TFunction = (key: string, options?: Record<string, unknown>) => string;

// Export the default i18next instance with overridden 't' function type
export default i18next as typeof i18next & {t: TFunction};
